import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useApiQuery } from "../../../../common/infrastructure/hooks/useApiQuery";
import { useApiMutation } from "../../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { NapVatStatus } from "../../../../common/enums";
import {
  IMyNapSettingsFormModel,
  myNapSettingsFormDefaultValues,
  myNapSettingsFormSchema,
} from "../models/myNapSettingsFormModel";

export interface IMyNapSettingsData {
  vatStatus: NapVatStatus | null;
  merchantEik: string | null;
  shopUin: string | null;
  shopDomain: string | null;
  vposNumber: string | null;
}

export const useMyNapSettingsForm = () => {
  const { data, isLoading, isFetching } = useApiQuery<IMyNapSettingsData>({
    queryKey: [endpointsMetadata.myNapSettings.getMyNapSettings],
    endpoint: endpointsMetadata.myNapSettings.getMyNapSettings,
    globalIsLoading: false,
  });

  const form = useForm<IMyNapSettingsFormModel>({
    resolver: yupResolver(myNapSettingsFormSchema),
    defaultValues: myNapSettingsFormDefaultValues,
  });

  useEffect(() => {
    if (data) {
      form.reset({
        vatStatus: data.vatStatus ?? NapVatStatus.NotRegistered,
        merchantEik: data.merchantEik ?? "",
        shopUin: data.shopUin ?? "",
        shopDomain: data.shopDomain ?? "",
        vposNumber: data.vposNumber ?? null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const { mutate, isLoading: isSaving } = useApiMutation({});

  const onSubmit = form.handleSubmit((values) => {
    mutate({
      endpoint: endpointsMetadata.myNapSettings.updateMyNapSettings,
      method: "put",
      payload: {
        vatStatus: values.vatStatus,
        merchantEik: values.merchantEik.trim(),
        shopUin: values.shopUin.trim(),
        shopDomain: values.shopDomain.trim(),
        vposNumber: values.vposNumber?.trim() || null,
      },
      successMessage: "НАП данните бяха запазени успешно.",
      invalidateKeys: [[endpointsMetadata.myNapSettings.getMyNapSettings]],
    });
  });

  return {
    form,
    isLoading: isLoading || isFetching,
    isSaving,
    onSubmit,
  };
};
